export const getCategoryLink = (
  categorySlug: string,
  subcategories?: HelpCenterCategoryModel[]
) => {
  if (!subcategories || subcategories?.length === 0) {
    return `/help-centre/${categorySlug}`
  }

  const subcategorySlug = subcategories[0]?.slug

  return `/help-centre/${subcategorySlug}`
}

export const getArticleCategoriesSlugs = (
  categories?: HelpCenterCategoryModel[]
) => {
  if (!categories || categories?.length === 0) {
    return { categorySlug: '' }
  }

  const categorySlug = categories[0]?.slug || ''
  const subcategories = categories[0]?.sub_categories

  if (!subcategories || subcategories?.length === 0) {
    return { categorySlug }
  }

  const subcategorySlug = subcategories[0]?.slug

  return { categorySlug, subcategorySlug }
}

export const hasArticleMultipleCategories = (
  categories?: HelpCenterCategoryModel[]
) => {
  if (!categories || categories?.length === 0) {
    return false
  }

  const subcategories = categories[0]?.sub_categories
  const hasMultipleCategories = categories?.length > 1
  const hasMultipleSubcategories = !!subcategories && subcategories?.length > 1

  return hasMultipleCategories || hasMultipleSubcategories
}
